import React, { PureComponent } from 'react'
import classnames from 'classnames'

import './Loader.css'

export default class Loader extends PureComponent {
  render() {
    const { loading } = this.props
    const classes = classnames('cm-loader', {
      'cm-loader__loading': loading
    })
    return <div ref={el => (this.element = el)} className={classes} />
  }
}



// WEBPACK FOOTER //
// ./src/components-utils/Loader.js